// removed by extract-text-webpack-plugin
module.exports = {"base":"_2ha4j","icon":"_1nof3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonIcon/ButtonIcon.scss
// module id = 1879
// module chunks = 0